import Login from './Login';

export default {
  name: 'Login',
  location: '/login',
  component: Login,
};
